import RS from '~/api';
import { KEY_AGENT_STORAGE } from '~/constants';
import generateUUID from '~/helpers/generateUUID';
import { getFromLocalStorage, saveToLocalStorage } from '~/helpers/storage';
import { clickstreamLogger } from '~/logging';

export const authenticateUser = (): Promise<void> => {
  const sessionId = RS.token.sessionId;

  const debugData: string[] = [];

  debugData.push(`ua:"${navigator.userAgent}"`);
  debugData.push(`session:"${sessionId}"`);
  debugData.push(
    `fe_uid:"${getFromLocalStorage(KEY_AGENT_STORAGE, 'userUID')}"`
  );
  debugData.push(`location:"${location.href}"`);

  // Get actual userUID webService
  return RS.deviceGUID
    .get()
    .then(({ payload, errorData }: any) => {
      if (payload && payload.length) {
        debugData.push(`backend_uid:"${payload[0].guid}"`);
      }

      if (errorData && errorData.errorFlag) {
        debugData.push(`try_error:"${errorData.errorText}"`);

        return Promise.reject();
      }

      const userUID = payload && payload.length ? payload[0].guid : generateUUID();

      // Update token userUID param
      RS.setParameters({ userUID });

      saveToLocalStorage(KEY_AGENT_STORAGE, 'userUID', userUID);

      clickstreamLogger.debug(
        `User authenticated successfully, userUID: ${userUID}`
      );

      return Promise.resolve();
    })
    .catch((e) => {
      if (e.errorData?.errorFlag) {
        debugData.push(`catch_error:"${e.errorData.errorText}"`);
      } else {
        debugData.push(`js_error:"${e.message}"`);
      }

      clickstreamLogger.debug(debugData.join('|'));

      return e;
    });
};
